export default __webpack_public_path__ + "static/media/maestro-carnet.f80287d1.jpg";